// jsapi
export function jsApiCall(param, call) {
  let jsApiParameters = {}
  jsApiParameters.appId = param.appId //公众号名称，由商户传入
  jsApiParameters.timeStamp = param.timeStamp //时间戳，自1970年以来的秒数
  jsApiParameters.nonceStr = param.nonceStr //随机串
  jsApiParameters.package = param.package
  jsApiParameters.signType = param.signType //微信签名方式：
  jsApiParameters.paySign = param.paySign //微信签名

  function onBridgeReady() {
    console.log(2)
    console.log('准备支付啦')

    console.log(jsApiParameters)

    window.WeixinJSBridge.invoke('getBrandWCPayRequest', jsApiParameters, function (res) {
      call && call(res)
      console.log('回调结果')
      console.log(res)
      if (res.err_msg == 'get_brand_wcpay_request:ok') {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
      }
    })
  }

  if (typeof WeixinJSBridge == 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
    }
  } else {
    onBridgeReady()
  }
}
